<template>
    <div class="test-edit-settings-item columns mx-0">
        <div
            class="column is-two-fifths-desktop p-0"
            :class="{'is-one-third-fullhd': !isFullscreen, 'is-one-fifth-fullhd': isFullscreen}"
        >
            <label class="label pr-1">
                {{ title }}
                <help-tooltip v-if="helpText" :text="helpText"/>
            </label>
        </div>
        <div
            class="column p-0 control is-align-items-center"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
import HelpTooltip from "../../../../utils/HelpTooltip";
export default {
    name: "TestEditSettingsItem",
    components: {HelpTooltip},
    props: {
        title: {
            type: String,
            default: '',
        },
        helpText: {
            type: String,
            default: '',
        },
        isFullscreen: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped lang="scss">
.bulma .tabs-container .tabs-details .test-edit-settings-item {
    .label {
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 19px;
        text-align: left;
        min-width: 137px;
        align-self: center;
    }
}
</style>